import { ME_PATH, SIGNOUT_PATH } from 'dpl/shared/constants/urls';

import { getUserIdFromWindow } from './';

export const currentUserQueryDefinition = {
  url: ME_PATH,
  enabled: Boolean(getUserIdFromWindow()),
  defaultValue: {
    meta: {},
    data: {}
  }
};

export const currentUserLoginMutationDefinition = {
  url: '/api/users/sign_in.json',
  method: 'POST',
  updateStrategy: 'success'
};

export const currentUserLogoutMutationDefinition = {
  url: SIGNOUT_PATH,
  method: 'DELETE'
};

export const notificationCountsQueryDefinition = {
  url: '/api/notifications.json',
  defaultValue: {
    meta: {},
    data: {}
  },
  enabled: Boolean(getUserIdFromWindow())
};

export function quizSectionMutationDefinition(submissionId, sectionUuid) {
  return {
    url: `/api/quiz_submissions/${submissionId}/quiz_sections/${sectionUuid}`,
    method: 'PUT'
  };
}

export function quizSubmissionResourceDefinition(submissionId, sectionIdx) {
  return {
    url: `/api/quiz_submissions/${submissionId}`,
    params: {
      section_idx: sectionIdx
    },
    defaultValue: {
      sections: []
    },
    staleTime: 0,
    cacheTime: 0,
    enabled: !!submissionId
  };
}

export function quizSubmissionMutationDefinition(submissionId) {
  return {
    url: `/api/quiz_submissions/${submissionId}`,
    method: 'PUT'
  };
}
